import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks/redux';
import { useDateFsnLocale } from '../../../hooks/useDateFsnLocale';
import { DateVOv2 } from '../../../core/DateVOv2';
import { CustomSkeletonElement } from '../../commons/CustomSkeletonElement';

interface FormToggleButtonRefactorProps {
  name: string;
  options: string[];
  handleToggleChange?: (value: string) => void;
  isLoading: boolean;
  isLoaded: boolean;
}

export const FormToggleButtonRefactor: FC<FormToggleButtonRefactorProps> = ({
  handleToggleChange,
  name,
  options,
  isLoading,
  isLoaded,
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { selectedLanguage } = useAppSelector((state) => state.langReducer);
  const { fnsLocale } = useDateFsnLocale(selectedLanguage);

  const getLable = (date: string) =>
    new DateVOv2({ dateString: date, format: 'dd-MM-yyyy' })
      .getLuxonKiev()
      .setLocale(fnsLocale?.code || 'uk')
      .toFormat('MMMM yyyy');

  return (
    <>
      <div className="payment__content__options__activation-period__title">
        <article className="payment__content__label">{t('servicePayment.choosePeriod')}</article>
      </div>
      {isLoaded ? (
        <FormControl component="fieldset">
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <ToggleButtonGroup
                  value={value}
                  onChange={(e, val) => {
                    onChange(e);
                    if (handleToggleChange) {
                      handleToggleChange(val);
                    }
                  }}
                  exclusive
                  className="input__toggle-button-group toggle-button-group"
                >
                  {options.map((el) => {
                    const label = getLable(el);
                    return (
                      <ToggleButton
                        key={label}
                        value={el}
                        style={isLoading ? { pointerEvents: 'none' } : {}}
                        className="toggle-button"
                      >
                        {label}
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              );
            }}
          />
        </FormControl>
      ) : (
        <CustomSkeletonElement
          skeletonContainerClassName="activation-period-skeleton"
          skeletonChildrenClassName="activation-period-skeleton__btn skeleton"
          childrenCount={2}
        />
      )}
    </>
  );
};
